






import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BaseMixin from '@/misc/BaseMixin';
import { namespace } from 'vuex-class';
import Magazine from '@/models/Magazine';

const MagazineStore = namespace('magazine');

@Component({
    components: {
        ReaderComponent: () => import(
            /* webpackChunkName: "ReaderComponent" */
            '@/components/reader/Reader.component.vue')
    }
})
export default class ReaderView extends mixins(BaseMixin) {

    @MagazineStore.Getter('selectedMagazine')
    private selectedMagazine!: Magazine;

    public created() {
        if (!this.selectedMagazine) { // Happens on reload or opening the reader without magazine selection
            this.$router.push({ name: 'library_view' });
            return;
        }

        this.setNavigationTitle({ title: this.selectedMagazine.name });
    }

};
